module.exports = __webpack_public_path__ + "img/expand.69019493.svg";